export default {
  loading: 'Loading refill...',
  errorTitle: 'Refill Not Found',
  notFound: 'The requested refill could not be found',
  fetchError: 'Failed to load refill',
  refillDetails: 'Refill Details',
  unitsAdded: 'units added',
  resource: 'Resource',
  refiller: 'Refiller',
  quantityAdded: 'Quantity Added',
  refilledAt: 'Refilled At',
  notes: 'Notes'
};
